import * as actiontypes from '../actions/actionTypes';
import initialState from '../store/initialState';

const gameVisibility = (state = initialState.gameVisibility, action) => {

    switch (action.type) {
        case actiontypes.HIDE_GAME:
            return false

        case actiontypes.SHOW_GAME:
            console.log('show_game');
            return true
        default:
            return state
    }
}

export default gameVisibility;



// WEBPACK FOOTER //
// ./src/reducers/gameVisibilityReducer.js